
//@module ContactUs
define(
	'ContactUs.Router'
,	[
		'ContactUs.View'
	,	'Backbone'
	]
,	function (
		ContactUsView
	,	Backbone
	)
{
	'use strict';

	// @lass ContactUs.Router @extends Backbone.Router
	return Backbone.Router.extend({

		routes: {
			'contact': 'contactUsPage'
		}

	,	initialize: function (application)
		{
			this.application = application;
		}

		// @method contactUsPage dispatch the 'go to contact us page' route
	,	contactUsPage: function ()
		{
			var view = new ContactUsView({application: this.application});
			view.showContent();
		}
	});
});
